import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parametricas',
  templateUrl: './parametricas.component.html',
  styleUrls: ['./parametricas.component.css']
})
export class ParametricasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
